import script from "./KnowledgeBaseEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseEditor.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseEditor.vue?vue&type=style&index=0&id=6898e1e0&lang=css"

const __exports__ = script;

export default __exports__